import axios from 'axios';

const backendUri = 'https://neoe2e.neophyte.live/fm-api/';

export const getTruckTurnaroundTime = async (data, signal) => {
  try {
    const response = await axios.post(`${backendUri}kpis/avg_truck_presence`, data, { signal });
    return response.data;
  } catch (error) {
    if (error.name === 'AbortError') {
      throw error;
    }
    console.error('Error getting truck turnaround time:', error);
    throw error;
  }
};

export const getMHEProductivity = async (data, signal) => {
  try {
    const response = await axios.post(`${backendUri}kpis/mhe_availability`, data, { signal });
    return response.data;
  } catch (error) {
    if (error.name === 'AbortError') {
      throw error;
    }
    console.error('Error getting MHE productivity:', error);
    throw error;
  }
};

export const getDeskAvailability = async (data, signal) => {
  try {
    const response = await axios.post(`${backendUri}kpis/avg_availability_desk`, data, { signal });
    return response.data;
  } catch (error) {
    if (error.name === 'AbortError') {
      throw error;
    }
    console.error('Error getting desk availability:', error);
    throw error;
  }
};

export const getBreakRoomDwellTime = async (data, signal) => {
  try {
    const response = await axios.post(`${backendUri}kpis/avg_dwell_time_count`, data, { signal });
    return response.data;
  } catch (error) {
    if (error.name === 'AbortError') {
      throw error;
    }
    console.error('Error getting break room dwell time:', error);
    throw error;
  }
};

export const getLineChartData = async (startDate, endDate, label) => {
  try {
    const response = await axios.post(`${backendUri}kpis/line_chart_track_id`, {
      startDate,
      endDate,
      label
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching line chart data:', error);
    throw error;
  }
};

export const unsafeMheCounts = async (startDate, endDate, label) => {
  try {
    const date = startDate.date;
    console.log(date);
    const response = await axios.post(`${backendUri}v2/unsafe_mhe_counts`, {
      startDate,
      endDate,
      date,
      label
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching line chart data:', error);
    throw error;
  }
};

export const peopleKpiCounts = async (startDate, endDate, label) => {
  try {
    const date = startDate.date;
    const response = await axios.post(`${backendUri}v2/people_kpi_counts`, {
      startDate,
      endDate,
      date,
      label
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching line chart data:', error);
    throw error;
  }
};

export const ppeKitSafetyVest = async (startDate, endDate, label) => {
  try {
    const date = startDate.date;
    const response = await axios.post(`${backendUri}v2/ppe_kit_safety_vest`, {
      startDate,
      endDate,
      date,
      label
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching line chart data:', error);
    throw error;
  }
};

export const ppeKitHelmet = async (startDate, endDate, label) => {
  try {
    const date = startDate.date;
    const response = await axios.post(`${backendUri}v2/ppe_kit_safety_vest`, {
      startDate,
      endDate,
      date,
      label
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching line chart data:', error);
    throw error;
  }
};
export const dockUtilization = async (startDate, endDate, label) => {
  try {
    const date = startDate.date;
    const response = await axios.post(`${backendUri}v2/dock_utilization`, {
      startDate,
      endDate,
      date,
      label
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching line chart data:', error);
    throw error;
  }
};

export const truckIdleTime = async (startDate, endDate, label) => {
  try {
    const date = startDate.date;
    const response = await axios.post(`${backendUri}v2/truck_idle_time`, {
      startDate,
      endDate,
      date,
      label
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching line chart data:', error);
    throw error;
  }
};

export const vehicleUnloaded = async (startDate, endDate, label) => {
  try {
    const date = startDate.date;
    const response = await axios.post(`${backendUri}v2/vehicle_unloaded`, {
      startDate,
      endDate,
      date,
      label
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching line chart data:', error);
    throw error;
  }
};

export const idleManPower = async (startDate, endDate, label) => {
  try {
    const date = startDate.date;
    const response = await axios.post(`${backendUri}v2/idle_man_power`, {
      startDate,
      endDate,
      date,
      label
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching line chart data:', error);
    throw error;
  }
};

export const truckInfo = async (startDate, endDate, label) => {
  try {
    const date = startDate.date;
    const response = await axios.post(`${backendUri}v2/truck_info`, {
      startDate,
      endDate,
      date,
      label
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching line chart data:', error);
    throw error;
  }
};
